import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import searchPoliceProfiles from "../axios/searchPoliceProfiles";

/**
 * @description This hook is similar to useQuerySearchPoliceProfiles but it automatically fetches all pages.
 */
const useQueryAllSearchPoliceProfiles = (searchTerm: string) => {
  const response = useInfiniteQuery(
    ["search_kepolisian_internasional", searchTerm],
    ({ pageParam = 1 }) => {
      return searchPoliceProfiles({ search: searchTerm, page: pageParam });
    },
    {
      enabled: Boolean(searchTerm.trim()),
      getNextPageParam: (lastPage, allPages) => {
        const policeProfilesList = allPages.flatMap(
          (page) => page.kepolisian_internasional.data,
        );
        if (
          policeProfilesList.length < lastPage.kepolisian_internasional.total
        ) {
          return lastPage.kepolisian_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );

  const { hasNextPage, isFetchingNextPage, fetchNextPage } = response;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return response;
};

export default useQueryAllSearchPoliceProfiles;
